import { Link } from 'react-router-dom';

const HomePage = () => {

  const chapters = [
    {
      id: 'chapter-01',
      title: 'Overview of Amateur Radio',
      subtitle: 'Chapter 1: Overview of Amateur Radio',
      completed: false
    },
    {
      id: 'chapter-02',
      title: 'Operating Procedures',
      subtitle: 'Chapter 2: Operating Procedures',
      completed: false
    },
    {
      id: 'chapter-03',
      title: 'Basic Electronics',
      subtitle: 'Chapter 3: Basic Electrical Concepts',
      completed: false
    },
    {
      id: 'chapter-04',
      title: 'Resistance and Ohm\'s Law',
      subtitle: 'Chapter 4: Understanding the Fundamental Relationship Between Voltage, Current, and Resistance',
      completed: false
    },
    {
      id: 'chapter-05',
      title: 'Resistors and Direct Current Circuits',
      subtitle: 'Chapter 5: Understanding Resistor Types, Color Codes, Potentiometers, and Kirchhoff\'s Laws',
      completed: false
    },
    {
      id: 'chapter-06',
      title: 'Capacitance and the Capacitor',
      subtitle: 'Chapter 6: Understanding Capacitors, Capacitive Reactance, and AC Circuit Behavior',
      completed: false
    },
    {
      id: 'chapter-07',
      title: 'Inductance and the Inductor',
      subtitle: 'Chapter 7: Understanding Inductors, Magnetic Fields, and Inductive Reactance',
      completed: false
    },
    {
      id: 'chapter-08',
      title: 'Alternating Current Concepts',
      subtitle: 'Chapter 8: Understanding Phase, RMS Values, and Frequency Ranges in AC Signals',
      completed: false
    },
    {
      id: 'chapter-09',
      title: 'Resonance and Q Factor',
      subtitle: 'Chapter 9: Understanding Tuned Circuits, Resonant Frequency, and Quality Factor in Amateur Radio',
      completed: false
    },
    {
      id: 'chapter-10',
      title: 'Decibels (dB)',
      subtitle: 'Chapter 10: Understanding Decibel Measurements',
      completed: false
    },
    {
      id: 'chapter-11',
      title: 'Transformers',
      subtitle: 'Chapter 11: Understanding Transformer Principles, Construction, and Applications in Amateur Radio',
      completed: false
    },
    {
      id: 'chapter-12',
      title: 'Semiconductors and the Diode',
      subtitle: 'Chapter 12: Semiconductors and the Diode',
      completed: false
    },
    {
      id: 'chapter-13',
      title: 'Power Supplies',
      subtitle: 'Chapter 13: Power Supplies',
      completed: false
    },
    {
      id: 'chapter-14',
      title: 'Amplifiers',
      subtitle: 'Chapter 14: Amplifiers',
      completed: false
    },
    {
      id: 'chapter-15',
      title: 'Oscillators',
      subtitle: 'Chapter 15: Oscillators',
      completed: false
    },
    {
      id: 'chapter-16',
      title: 'Filters',
      subtitle: 'Chapter 16: Filters',
      completed: false
    },
    {
      id: 'chapter-17',
      title: 'The Bipolar Junction Transistor',
      subtitle: 'Chapter 17: The Bipolar Junction Transistor',
      completed: false
    },
    {
      id: 'chapter-18',
      title: 'The Transistor Amplifier',
      subtitle: 'Chapter 18: The Transistor Amplifier',
      completed: false
    },
    {
      id: 'chapter-19',
      title: 'The Oscillator',
      subtitle: 'Chapter 19: The Oscillator',
      completed: false
    },
    {
      id: 'chapter-20',
      title: 'Frequency Translation',
      subtitle: 'Chapter 20: Frequency Translation',
      completed: false
    },
    {
      id: 'chapter-21',
      title: 'Modulation and Demodulation',
      subtitle: 'Chapter 21: Modulation and Demodulation',
      completed: false
    },
    {
      id: 'chapter-22',
      title: 'Transmitter Fundamentals',
      subtitle: 'Chapter 22: Transmitter Fundamentals',
      completed: false
    },
    {
      id: 'chapter-23',
      title: 'Receiver Fundamentals',
      subtitle: 'Chapter 23: Receiver Fundamentals',
      completed: false
    },
    {
      id: 'chapter-24',
      title: 'The Superheterodyne Receiver',
      subtitle: 'Chapter 24: The Superheterodyne Receiver',
      completed: false
    },
    {
      id: 'chapter-25',
      title: 'Transceivers and Transverters',
      subtitle: 'Chapter 25: Transceivers and Transverters',
      completed: false
    },
    {
      id: 'chapter-26',
      title: 'Antennas',
      subtitle: 'Chapter 26: Antennas',
      completed: false
    },
    {
      id: 'chapter-27',
      title: 'Propagation',
      subtitle: 'Chapter 27: Propagation',
      completed: false
    },
    {
      id: 'chapter-28',
      title: 'Electromagnetic Compatibility',
      subtitle: 'Chapter 28: Electromagnetic Compatibility',
      completed: false
    },
    {
      id: 'chapter-29',
      title: 'Measurements',
      subtitle: 'Chapter 29: Measurements',
      completed: false
    },
    {
      id: 'chapter-30',
      title: 'Digital Systems',
      subtitle: 'Chapter 30: Digital Systems',
      completed: false
    },
    {
      id: 'chapter-31',
      title: 'Digital Communication Modes',
      subtitle: 'Chapter 31: Digital Communication Modes',
      completed: false
    },
    {
      id: 'chapter-32',
      title: 'Safety Considerations',
      subtitle: 'Chapter 32: Safety Considerations',
      completed: false
    }
  ];

  const regulations = [
    {
      id: 'regulation-01-preliminary-definitions',
      title: 'Preliminary & Definitions',
      subtitle: 'Part I: Legal Definitions and Technical Terms',
      completed: false
    },
    {
      id: 'regulation-02-licensing-procedures',
      title: 'Licensing Procedures',
      subtitle: 'Part IV: License Applications and Renewals',
      completed: false
    },
    {
      id: 'regulation-03-license-terms-conditions',
      title: 'License Terms & Conditions',
      subtitle: 'Part V: Duration, Fees, and Basic Conditions',
      completed: false
    },
    {
      id: 'regulation-04-amateur-station-operations',
      title: 'Amateur Station Operations',
      subtitle: 'Part V: Station Licensing and Operating Requirements',
      completed: false
    },
    {
      id: 'regulation-05-general-provisions',
      title: 'General Provisions',
      subtitle: 'Part VII: Call Signs, Modifications, and Compliance',
      completed: false
    },
    {
      id: 'regulation-06-rights-liability-penalties',
      title: 'Rights, Liability & Penalties',
      subtitle: 'Part VIII: Legal Rights, Costs, and Enforcement',
      completed: false
    },
    {
      id: 'regulation-07-frequency-allocations-call-signs',
      title: 'Frequency Allocations & Call Signs',
      subtitle: 'Annexures: Band Plans, Modes, and Call Sign Zones',
      completed: false
    }
  ];

  return (
    <div className="container mx-auto px-4 sm:px-6 py-6 sm:py-8">
      <header className="text-center mb-8 sm:mb-12">
        <div className="flex flex-col sm:flex-row sm:justify-between sm:items-start mb-4 space-y-4 sm:space-y-0">
          <div className="hidden sm:block sm:flex-1"></div>
          <h1 className="text-3xl sm:text-4xl font-bold text-gray-900">
            HAM Student
          </h1>
          <div className="sm:flex-1 sm:flex sm:justify-end">
            
          </div>
        </div>
        <p className="text-lg sm:text-xl text-gray-600 max-w-2xl mx-auto mb-6 sm:mb-8 px-2">
          Amateur Radio Learning Platform - Learn to get your South African Amateur Radio License
        </p>
        
        {/* Mock Exam Call-to-Action */}
        <div className="bg-gradient-to-r from-blue-600 to-blue-700 text-white rounded-lg p-4 sm:p-6 max-w-2xl mx-auto mb-6 sm:mb-8">
          <h2 className="text-xl sm:text-2xl font-bold mb-2">Ready for the Real Exam?</h2>
          <p className="text-blue-100 mb-4 text-sm sm:text-base">
            Test your knowledge with a full 100-question mock exam
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-3">
            <Link
              to="/mock-exam"
              className="inline-block bg-white text-blue-600 px-6 py-3 rounded-md font-semibold hover:bg-blue-50 transition-colors shadow-lg text-sm sm:text-base touch-manipulation"
            >
              Take Mock Exam
            </Link>
            <Link
              to="/mock-exam-v2"
              className="inline-block bg-white text-blue-600 px-6 py-3 rounded-md font-semibold hover:bg-blue-50 transition-colors shadow-lg text-sm sm:text-base touch-manipulation"
            >
              Take Mock Exam V2
            </Link>
          </div>
        </div>
      </header>

      <div className="max-w-4xl mx-auto">
        <h2 className="text-xl sm:text-2xl font-semibold text-gray-900 mb-4 sm:mb-6">
          Quick Reference Quizzes
        </h2>
        
        <div className="grid gap-4 sm:gap-6 sm:grid-cols-2 lg:grid-cols-3 mb-8 sm:mb-12">
          <Link
            to="/qcodes-quiz"
            className="block bg-white rounded-lg shadow-md hover:shadow-lg active:shadow-lg transition-shadow duration-300 p-4 sm:p-6 border-l-4 border-blue-500 touch-manipulation"
          >
            <div className="flex items-start justify-between mb-3">
              <h3 className="text-base sm:text-lg font-semibold text-gray-900 leading-tight">
                Q Codes
              </h3>
              <span className="text-2xl">📻</span>
            </div>
            
            <p className="text-xs sm:text-sm text-gray-600 mb-2 leading-relaxed">
              Master essential amateur radio Q codes used in communication
            </p>
            
            <div className="mt-3 sm:mt-4 text-blue-600 text-xs sm:text-sm font-medium">
              Start Quiz →
            </div>
          </Link>

          <Link
            to="/bands-quiz"
            className="block bg-white rounded-lg shadow-md hover:shadow-lg active:shadow-lg transition-shadow duration-300 p-4 sm:p-6 border-l-4 border-green-500 touch-manipulation"
          >
            <div className="flex items-start justify-between mb-3">
              <h3 className="text-base sm:text-lg font-semibold text-gray-900 leading-tight">
                Amateur Radio Bands
              </h3>
              <span className="text-2xl">📡</span>
            </div>
            
            <p className="text-xs sm:text-sm text-gray-600 mb-2 leading-relaxed">
              Learn amateur radio frequency band allocations and ranges
            </p>
            
            <div className="mt-3 sm:mt-4 text-blue-600 text-xs sm:text-sm font-medium">
              Start Quiz →
            </div>
          </Link>

          <Link
            to="/rst-quiz"
            className="block bg-white rounded-lg shadow-md hover:shadow-lg active:shadow-lg transition-shadow duration-300 p-4 sm:p-6 border-l-4 border-purple-500 touch-manipulation"
          >
            <div className="flex items-start justify-between mb-3">
              <h3 className="text-base sm:text-lg font-semibold text-gray-900 leading-tight">
                RS System
              </h3>
              <span className="text-2xl">📊</span>
            </div>
            
            <p className="text-xs sm:text-sm text-gray-600 mb-2 leading-relaxed">
              Master the RS signal reporting system (Readability and Signal Strength)
            </p>
            
            <div className="mt-3 sm:mt-4 text-blue-600 text-xs sm:text-sm font-medium">
              Start Quiz →
            </div>
          </Link>

          <Link
            to="/resistors-quiz"
            className="block bg-white rounded-lg shadow-md hover:shadow-lg active:shadow-lg transition-shadow duration-300 p-4 sm:p-6 border-l-4 border-orange-500 touch-manipulation"
          >
            <div className="flex items-start justify-between mb-3">
              <h3 className="text-base sm:text-lg font-semibold text-gray-900 leading-tight">
                Resistor Color Codes
              </h3>
              <span className="text-2xl">🔌</span>
            </div>
            
            <p className="text-xs sm:text-sm text-gray-600 mb-2 leading-relaxed">
              Learn to read resistor color bands and calculate resistance values
            </p>
            
            <div className="mt-3 sm:mt-4 text-blue-600 text-xs sm:text-sm font-medium">
              Start Quiz →
            </div>
          </Link>
        </div>

        <h2 className="text-xl sm:text-2xl font-semibold text-gray-900 mb-4 sm:mb-6">
          Chapters
        </h2>
        
        <div className="grid gap-4 sm:gap-6 sm:grid-cols-2 lg:grid-cols-3 mb-8 sm:mb-12">
          {chapters.map((chapter) => (
            <Link
              key={chapter.id}
              to={`/chapter/${chapter.id}`}
              className="block bg-white rounded-lg shadow-md hover:shadow-lg active:shadow-lg transition-shadow duration-300 p-4 sm:p-6 touch-manipulation"
            >
              <div className="flex items-start justify-between mb-3">
                <h3 className="text-base sm:text-lg font-semibold text-gray-900 leading-tight">
                  {chapter.title}
                </h3>
                {chapter.completed && (
                  <span className="text-green-500 text-xs sm:text-sm flex-shrink-0 ml-2">✓ Completed</span>
                )}
              </div>
              
              <p className="text-xs sm:text-sm text-gray-600 mb-2 leading-relaxed">
                {chapter.subtitle}
              </p>
              
              <div className="mt-3 sm:mt-4 text-blue-600 text-xs sm:text-sm font-medium">
                Start Quiz →
              </div>
            </Link>
          ))}
        </div>

        <h2 className="text-xl sm:text-2xl font-semibold text-gray-900 mb-4 sm:mb-6">
          Regulations
        </h2>
        
        <div className="grid gap-4 sm:gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {regulations.map((regulation) => (
            <Link
              key={regulation.id}
              to={`/regulation/${regulation.id}`}
              className="block bg-white rounded-lg shadow-md hover:shadow-lg active:shadow-lg transition-shadow duration-300 p-4 sm:p-6 border-l-4 border-gray-300 touch-manipulation"
            >
              <div className="flex items-start justify-between mb-3">
                <h3 className="text-base sm:text-lg font-semibold text-gray-900 leading-tight">
                  {regulation.title}
                </h3>
                {regulation.completed && (
                  <span className="text-green-500 text-xs sm:text-sm flex-shrink-0 ml-2">✓ Completed</span>
                )}
              </div>
              
              <p className="text-xs sm:text-sm text-gray-600 mb-2 leading-relaxed">
                {regulation.subtitle}
              </p>
              
              <p className="text-gray-700 text-xs sm:text-sm">
                {regulation.description}
              </p>
              
              <div className="mt-3 sm:mt-4 text-blue-600 text-xs sm:text-sm font-medium">
                Start Quiz →
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default HomePage;